module.exports = {
  DEV_API_ROOT: 'https://stage.micro.riselinkedu.com', // 开发环境
  // DEV_API_ROOT: 'https://micro.riselinkedu.com', // 冯阳机器
  TEST_API_ROOT: 'https://test.micro.riselinkedu.com',
  STAGE_API_ROOT: 'https://stage.micro.riselinkedu.com',
  DEMO_API_ROOT: 'https://demo.micro.riselinkedu.com',
  PROD_API_ROOT: 'https://micro.riselinkedu.com',
  LOCAL_API_ROOT: 'http://117.50.12.51:8088',
};